import { useRef } from "react";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { TECH_STACK, techIconUrl } from "@/data/site";

export default function TechStack() {
  const scrollerRef = useRef(null);

  const scrollBy = (dir) => {
    const el = scrollerRef.current;
    if (!el) return;
    el.scrollBy({ left: dir * (el.clientWidth * 0.85), behavior: "smooth" });
  };

  return (
    <section
      className="relative py-8 md:py-12 overflow-hidden"
      data-testid="tech-stack-section"
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <div className="text-xs font-mono uppercase tracking-[0.25em] text-muted-foreground">
              Tech stack
            </div>
            <h2 className="mt-4 font-heading font-bold text-3xl sm:text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.02] whitespace-nowrap">
              Technologies We Love Working With
            </h2>
            <p className="mt-5 text-lg text-muted-foreground max-w-xl">
              Best-in-class AI models, cloud, mobile and web frameworks — the stack our engineers ship every day.
            </p>
          </div>
          <div className="flex gap-3">
            <button
              onClick={() => scrollBy(-1)}
              aria-label="Previous technologies"
              data-testid="tech-prev"
              className="w-11 h-11 rounded-full border border-border hover:bg-muted transition-colors flex items-center justify-center"
            >
              <ArrowLeft className="w-4 h-4" />
            </button>
            <button
              onClick={() => scrollBy(1)}
              aria-label="Next technologies"
              data-testid="tech-next"
              className="w-11 h-11 rounded-full border border-border hover:bg-muted transition-colors flex items-center justify-center"
            >
              <ArrowRight className="w-4 h-4" />
            </button>
          </div>
        </div>

        {/* Scrollable strip with big transparent PNG/SVG icons — no card backgrounds */}
        <div
          ref={scrollerRef}
          className="flex items-end gap-10 md:gap-14 overflow-x-auto snap-x scroll-smooth pb-4 -mx-2 px-2 no-scrollbar"
          data-testid="tech-strip"
        >
          {TECH_STACK.map((t) => (
            <div
              key={t.key}
              className="group shrink-0 snap-start flex flex-col items-center gap-3 select-none"
              data-testid={`tech-icon-${t.key}`}
            >
              <img
                src={techIconUrl(t.key)}
                alt={t.name}
                loading="lazy"
                draggable={false}
                className="w-20 h-20 md:w-24 md:h-24 object-contain transition-transform duration-300 group-hover:scale-110 group-hover:-translate-y-1"
                style={{ filter: "drop-shadow(0 12px 20px rgba(15, 23, 42, 0.12))" }}
              />
              <div className="text-center">
                <div className="font-heading font-semibold text-sm">{t.name}</div>
                <div className="text-[10px] font-mono uppercase tracking-[0.2em] text-muted-foreground mt-0.5">
                  {t.cat}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
